import React, { FC, useEffect, useState } from 'react';
import { Icons } from '@components/Icon';
import useTranslations from '@hooks/useTranslation';
import { COMPONENT_TYPE, IColors, IConferenceItem } from '../../interfaces/Conference';
import {
    ContactMap,
    ContactSection,
    ContactSectionAddress,
    ContactSectionIcon,
    ContactSectionLink,
    ContactSectionPerson,
    ContactSectionRow,
    ContactSectionTitle,
    ContactSectionTitlePlace,
    Contacts,
    Coordinates,
    Icon,
    Map,
    PointIcon,
    Sections,
    Title,
    TitleSymbol,
    Wrapper,
} from './ConferenceContact.elements';

interface ConferenceProps {
    colors?: IColors;
    conf?: IConferenceItem;
}

const ConferenceContactTemplate: FC<ConferenceProps> = ({ colors, conf }) => {
    const { t } = useTranslations();

    const [eventDate, setEventDate] = useState(null);
    const [venues, setVenues] = useState([]);

    useEffect(() => {
        if (conf?.dates) {
            setEventDate(conf?.dates);
        }
    }, []);

    useEffect(() => {
        if (eventDate) {
            for (let x = 0; x < eventDate.length; x++) {
                for (let z = 0; z < eventDate[x].venues.length; z++) {
                    venues.push(eventDate[x]?.venues[z]);
                }
            }
            const venuesUnique = venues.filter(
                (value, index, self) => self.map((x) => x._key).indexOf(value._key) == index
            );
            setVenues(venuesUnique);
        }
    }, [eventDate]);

    return (
        <Wrapper id={`confSection${COMPONENT_TYPE.CONTACT}`}>
            <Title colors={colors}>
                {t('conference.component.contact.title')}
                <TitleSymbol colors={colors} />
            </Title>
            <Sections>

                {conf?.conference?.type === 0 && (
                    <Contacts>
                        <ContactSection>
                            <ContactSectionRow>
                                <ContactSectionPerson>{t('conference.contact.info')}</ContactSectionPerson>
                            </ContactSectionRow>

                            <ContactSectionRow>
                                <ContactSectionIcon name={Icons.Phone} colors={colors} />
                                <ContactSectionLink colors={colors} href="tel:+420 212 247 824">
                                    +420 212 247 824
                                </ContactSectionLink>
                            </ContactSectionRow>
                            <ContactSectionRow>
                                <ContactSectionIcon name={Icons.MailOpen} colors={colors} />
                                <ContactSectionLink colors={colors} href="mailto:studiow@pp.cz">
                                    studiow@pp.cz
                                </ContactSectionLink>
                            </ContactSectionRow>

                            <ContactSectionRow paddingTop={30}>
                                <ContactSectionPerson>Partnerství a zájem o vystoupení:</ContactSectionPerson>
                            </ContactSectionRow>
                            <ContactSectionRow>
                                <ContactSectionTitle withoutPaddingTop>Šárka Jurečková</ContactSectionTitle>
                            </ContactSectionRow>
                            <ContactSectionRow>
                                <ContactSectionIcon name={Icons.Phone} colors={colors} />
                                <ContactSectionLink colors={colors} href="tel:+420 602 398 155">
                                    +420 602 398 155
                                </ContactSectionLink>
                            </ContactSectionRow>
                            <ContactSectionRow>
                                <ContactSectionIcon name={Icons.MailOpen} colors={colors} />
                                <ContactSectionLink colors={colors} href="mailto:jureckova@pp.cz">
                                    jureckova@pp.cz
                                </ContactSectionLink>
                            </ContactSectionRow>
                        </ContactSection>
                    </Contacts>
                )}

                {conf?.conference?.type === 1 && (
                    <Contacts>
                        <ContactSection>
                            <ContactSectionRow>
                                <ContactSectionPerson>{t('conference.contact.info')}</ContactSectionPerson>
                            </ContactSectionRow>

                            <ContactSectionRow>
                                <ContactSectionIcon name={Icons.Phone} colors={colors} />
                                <ContactSectionLink colors={colors} href="tel:+420 212 247 811">
                                    +420 212 247 811
                                </ContactSectionLink>
                            </ContactSectionRow>
                            <ContactSectionRow>
                                <ContactSectionIcon name={Icons.MailOpen} colors={colors} />
                                <ContactSectionLink colors={colors} href="mailto:blahutova@pp.cz">
                                    blahutova@pp.cz
                                </ContactSectionLink>
                            </ContactSectionRow>
                            <ContactSectionRow>
                                <ContactSectionIcon name={Icons.MailOpen} colors={colors} />
                                <ContactSectionLink colors={colors} href="mailto:kosutova@pp.cz">
                                    kosutova@pp.cz
                                </ContactSectionLink>
                            </ContactSectionRow>

                            <ContactSectionRow paddingTop={30}>
                                <ContactSectionPerson>Partnerství a zájem o vystoupení:</ContactSectionPerson>
                            </ContactSectionRow>
                            <ContactSectionRow>
                                <ContactSectionTitle withoutPaddingTop>Miroslav Růžička</ContactSectionTitle>
                            </ContactSectionRow>
                            <ContactSectionRow>
                                <ContactSectionIcon name={Icons.Phone} colors={colors} />
                                <ContactSectionLink colors={colors} href="tel:+420 737 518 210">
                                    +420 737 518 210
                                </ContactSectionLink>
                            </ContactSectionRow>
                            <ContactSectionRow>
                                <ContactSectionIcon name={Icons.MailOpen} colors={colors} />
                                <ContactSectionLink colors={colors} href="mailto:ruzicka@pp.cz">
                                    ruzicka@pp.cz
                                </ContactSectionLink>
                            </ContactSectionRow>
                        </ContactSection>
                    </Contacts>
                )}

                <Map>
                    {venues.length > 0 && (
                        <>
                            <PointIcon>
                                <Icon name={Icons.Point} colors={colors} />
                            </PointIcon>
                            <ContactSectionTitlePlace>{t('conference.contact.venue')}</ContactSectionTitlePlace>
                            <ContactSectionAddress>{venues[0]?.name}</ContactSectionAddress>
                            <ContactSectionAddress>{venues[0]?.street}</ContactSectionAddress>
                            <ContactSectionAddress>
                                {venues[0]?.zip_code}, {venues[0]?.city}
                            </ContactSectionAddress>
                            {venues[0]?.iframe &&
                                <Coordinates>
                                    {t('conference.contact.gps')}{' '}
                                    {`${venues[0]?.iframe?.split('!')[5]?.substr(2)}, ${venues[0]?.iframe
                                        ?.split('!')[6]
                                        ?.substr(2)}`}
                                </Coordinates>
                            }
                            <ContactMap dangerouslySetInnerHTML={{ __html: venues[0]?.iframe }}></ContactMap>
                        </>
                    )}
                </Map>
            </Sections>
        </Wrapper>
    );
};

export default ConferenceContactTemplate;
